import { render, staticRenderFns } from "./AttrDialog.vue?vue&type=template&id=92ba2a7c&scoped=true"
import script from "./AttrDialog.vue?vue&type=script&lang=js"
export * from "./AttrDialog.vue?vue&type=script&lang=js"
import style0 from "./AttrDialog.vue?vue&type=style&index=0&id=92ba2a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ba2a7c",
  null
  
)

export default component.exports